import { useTranslation } from 'react-i18next';
import { Flex, Heading, Text } from '@radix-ui/themes';
import { Callout, PillToggle } from '@/components/common';
import { WizardScreen } from '@/components/layout';
import { ContinueButton, OnboardingWizardHeader } from '@/components/onboarding';
import { V90_LANGUAGE_OPTIONS } from '@/constants';
import { useOnboardingStore } from '@/stores/onboardingStore';
import { fieldLabelStyle } from './styles';
import type { OnboardingStepProps } from './types';
import { useSaveAndNext } from './useSaveAndNext';

export function LanguagesStep({ flow }: OnboardingStepProps) {
  const { t } = useTranslation('onboarding');
  const selectedLanguages = useOnboardingStore(state => state.selectedLanguages);
  const setSelectedLanguages = useOnboardingStore(state => state.setSelectedLanguages);
  const saveAndNext = useSaveAndNext(flow);

  return (
    <WizardScreen header={<OnboardingWizardHeader flow={flow} onSkip={flow.skip} />}>
      <Flex direction="column" gap="4" py="2" pb="5">
        <Heading size="5" weight="light">
          {t('steps.languages.title')}{' '}
          <Text size="1" color="gray" as="span">
            {t('steps.languages.optional')}
          </Text>
        </Heading>
        <Callout>{t('steps.languages.callout')}</Callout>
        <Flex direction="column" gap="1">
          <Text size="1" color="gray" style={fieldLabelStyle}>
            {t('steps.languages.fieldLabel')}
          </Text>
          <PillToggle
            type="multiple"
            options={V90_LANGUAGE_OPTIONS}
            value={selectedLanguages}
            onValueChange={setSelectedLanguages}
          />
        </Flex>
        <ContinueButton onClick={saveAndNext}>{t('actions.continue')}</ContinueButton>
      </Flex>
    </WizardScreen>
  );
}
